import React from 'react'
import './styles/ProductCard.scss'

type Props = {
  title: string
  type: 'folder' | 'item'
  onClick?: (e?: any) => any
  className?: string
  currentIssues?: number
}

const ProductCard = (props: Props) => {
  const { title, type, onClick, className, currentIssues } = props

  return (
    <div
      onClick={onClick}
      className={`card ${type === 'folder' ? 'card-folder' : ''} ${
        className ?? ''
      }`}
    >
      {currentIssues && type === 'folder' ? (
        <div className="card-currentIssues">{currentIssues}</div>
      ) : null}
      <div className="card-image"></div>
      <div className="card-info">
        <div className="card-info-title">{title}</div>
      </div>
    </div>
  )
}

export default ProductCard
